import {Search2Icon} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Checkbox,
  HStack,
  Input, Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useQuery} from "react-query";
import {useParams} from "react-router-dom";

import Admin from "../../admin/components/Admin";
import {getLicenses} from "../Api";
import {useAuthentication} from "../hooks/AuthenticationProvider";
import {disableBlurProtection} from "../hooks/BlurProtection";
import {Authority} from "../model/Constants";
import {adminKeys} from "../QueryKeys";
import {
  enableKeyCommands,
  extractData,
  toIsoString
} from "../Utils";
import DownloadLicensesResults from './DownloadLicensesResults';
import LicenseItem from "./LicenseItem";

const LicensesList = (props: {isPublic?:boolean} ) => {
  const params = useParams<{
    institution: string;
  }>();

  disableBlurProtection();
  enableKeyCommands();

  const authentication = useAuthentication();
  const isAdmin =
    authentication?.currentUserQuery?.data?.data?.authorities?.includes(Authority.ROLE_ADMIN);
  const noInstitution = !authentication.currentUserQuery?.data?.data?.institution;
  const [institutionValue, setInstitutionValue] = useState<string>(
    props.isPublic ? params?.institution?.trim().toLowerCase() || "" :
      authentication.currentUserQuery?.data?.data?.institution?.trim().toLowerCase() || "");

  const today: string = toIsoString(new Date()).slice(0, 10);

  const minDate: string = institutionValue==="aliarse"?"2024-06-01": "2022-12-01";
  const [startDateValue, setStartDateValue] = useState<string>(today);
  const [endDateValue, setEndDateValue] = useState<string>(today);

  const [regionValue, setRegionValue] = useState<string>("");
  const [licenseValue, setLicenseValue] = useState<string>("");
  const [idValue, setIdValue] = useState<string>("");
  const [nameValue, setNameValue] = useState<string>("");

  // public should only get used licenses
  const [includeAvailable, setIncludeAvailable] = useState<boolean>(
    false
  );
  const [includeUnavailable, setIncludeUnavailable] = useState<boolean>(
    true
  );
  const [includeInvited, setIncludeInvited] = useState<boolean>(false);
  const [includeInProgress, setIncludeInProgress] = useState<boolean>(true);
  const [includeCompleted, setIncludeCompleted] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);

  const licensesQuery = useQuery(adminKeys.candidatesSummary(), () =>
      getLicenses({
        licenseValue: licenseValue.trim().toLowerCase(),
        usernameValue: idValue.trim().toLowerCase(),
        nameValue: nameValue.trim().toLowerCase(),
        startDateValue: startDateValue,
        endDateValue: endDateValue,
        institution: institutionValue.trim().toLowerCase(),
        region: regionValue.trim().toLowerCase(),
        includeInvited: includeInvited,
        includeInProgress: includeInProgress,
        includeCompleted: includeCompleted,
        includeAvailable: includeAvailable,
        includeUnavailable: includeUnavailable,
        isPublic: props.isPublic
      } ).then(extractData),
    {retry: true, refetchOnWindowFocus: false, enabled: false}
  );

  function handleKeyPress (key: string) {
    if (key === 'Enter') {
      return licensesQuery.refetch();
    }
  }

    return (
      <Box width="95%" marginX="auto">
        <div>
          <HStack alignSelf="start" spacing={10}>
            { !props.isPublic && <DownloadLicensesResults endDateValue={endDateValue} startDateValue={startDateValue}
                                                          institution={institutionValue.trim().toLowerCase()}
                                                          includeInvited={includeInvited} includeInProgress={includeInProgress}
                                                          includeCompleted={includeCompleted} includeAvailable={includeAvailable}
                                                          includeUnavailable={includeUnavailable}
                                                          region={regionValue.trim().toLowerCase()}
                                                          nameValue={nameValue.trim().toLowerCase()}
                                                          licenseValue={licenseValue.trim().toLowerCase()}
                                                          usernameValue={idValue.trim().toLowerCase()}
            />}
            { (noInstitution && !props.isPublic) &&
              <Input placeholder='Institución'
                     onKeyDown={(event) => handleKeyPress(event.key)}
                     onChange={(event)=>
                       setInstitutionValue(event.target.value.trim().toLowerCase())}/>
            }
            { (!props.isPublic) &&
              <Input placeholder='Región'
                     onKeyDown={(event) => handleKeyPress(event.key)}
                     onChange={(event)=>
                       setRegionValue(event.target.value.trim().toLowerCase())}/>
            }
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={2}>
            <Input type="date" id="startDate" value={startDateValue}
                   min={minDate}
                   onChange={(event) => {
                     setStartDateValue(event.target.value);
                   }}/>
            <Input type="date" id="endDate" value={endDateValue}
                   min={minDate}
                   onChange={ (event) => {
                     setEndDateValue(event.target.value);
                   }}/>
            <Checkbox minW="fit-content"
                      onChange={ (e) => {
                        setIncludeInvited(e.target.checked);
                      }}
                      defaultChecked={includeInvited}>
              Sin iniciar
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={ (e) => {
                        setIncludeInProgress(e.target.checked);
                      }}
                      defaultChecked={includeInProgress}>
              En proceso
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={ (e) => {
                        setIncludeCompleted(e.target.checked);
                      }}
                      defaultChecked={includeCompleted}>
              Completados
            </Checkbox>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={2}>
            <Input placeholder='Licencia'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setLicenseValue(event.target.value)}/>
            <Input placeholder='Identificación'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setIdValue(event.target.value)}/>
            <Input placeholder='Nombre'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setNameValue(event.target.value)} />
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={2}>
            <Select value={pageSize.toString()} isReadOnly={true} width="1xs"
                    onChange={(event)=> {setPageSize(parseInt(event.target.value)); }}>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </Select>

            <Button leftIcon={<Search2Icon />} colorScheme="teal" onClick={()=> {
              setPage(0);
              return licensesQuery.refetch();
            }}
                    disabled={licensesQuery.isFetching}>
              Buscar
            </Button>

            { !props.isPublic && <Checkbox minW="fit-content"
                                           onChange={ (e) => {
                                             setIncludeAvailable(e.target.checked);
                                           }}
                                           defaultChecked={includeAvailable}>
              Desocupadas
            </Checkbox>}
            { !props.isPublic && <Checkbox minW="fit-content"
                                           onChange={ (e) => {
                                             setIncludeUnavailable(e.target.checked);
                                           }}
                                           defaultChecked={includeUnavailable}>
              Ocupadas
            </Checkbox>
            }

            {licensesQuery.isFetching &&
              <Spinner />
            }
          </HStack >
        </div>

        <TableContainer width="95vw">
          <Table size='sm' variant='striped' whiteSpace="normal">
            <Thead>
              <Tr>
                <Th>Licencia</Th>
                <Th>ID</Th>
                <Th>Nombre</Th>
                <Th>Institución</Th>
                <Th>Grupo</Th>
                { !props.isPublic && <Th>Constancia</Th> }
                <Th>Reading - estado</Th>
                <Th>Inicio</Th>
                <Th>Fin</Th>
                <Th>Última Pregunta</Th>
                { !props.isPublic && <Th>Banda</Th> }
                { !props.isPublic && institutionValue==="tweetalig" && <Th>Puntaje</Th> }
                <Th>Listening - estado</Th>
                <Th>Inicio</Th>
                <Th>Fin</Th>
                <Th>Última Pregunta</Th>
                { !props.isPublic && <Th>Banda</Th> }
                { !props.isPublic && institutionValue==="tweetalig" && <Th>Puntaje</Th> }
                <Th>Speaking - estado</Th>
                <Th>Inicio</Th>
                <Th>Fin</Th>
                { !props.isPublic && <Th>Banda</Th> }
                { isAdmin && <Th>Reporte</Th>}
                { !props.isPublic && institutionValue==="tweetalig" && <Th>Puntaje</Th> }
                { !props.isPublic && <Th>Overall</Th> }
              </Tr>
            </Thead>

            <Tbody key="List">
              {licensesQuery.isSuccess && licensesQuery.data.length ? (
                (licensesQuery.data).slice(page, page+pageSize).map((license) => (
                  <LicenseItem license={license}
                               userInstitution={institutionValue}
                               isAdmin={isAdmin}
                               isPublic={props.isPublic} />
                ))
              ) : (
                <Tr key={"empty"}>
                </Tr>
              )}

            </Tbody>
          </Table>
        </TableContainer>
        <HStack paddingY={10} justifyContent="end">
          <Button
            colorScheme="teal"
            disabled={page === 0}
            onClick={()=>setPage(page-pageSize)}
          >
            Anterior
          </Button>
          <Button
            colorScheme="teal"
            disabled={!licensesQuery.data || page+pageSize >= (licensesQuery.data).length}
            onClick={()=>setPage(page+pageSize)}
          >
            Siguiente
          </Button>
        </HStack>
      </Box>
    );
};

export default LicensesList;
